/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {
  findCurrentAccountMatch,
  sanitizeAccount,
  setAccountTree
} from '@ion/core/src/entities/Accounts';
import EntityLabel from '@ion/core/src/entities/EntityLabel';
import {entityId} from '@ion/core/src/services/ConnectUtils';

export const buildCrumbList = ({
  account,
  tree,
  handleCrumbClick
}) => {
  const list = [];

  function makeCrumbList({
    account,
    tree
  }) {
    if (account?.subAccounts || account?.parentId) {
      list.unshift({
        title       : account.title,
        href        : account.href,
        subAccounts : account.subAccounts
      });
    }
    if (tree[entityId(account)].parentId) {
      makeCrumbList({
        account : tree[entityId(account)].parentId,
        tree
      });
    }
  };

  makeCrumbList({
    account : account,
    tree
  });
  const crumbsList = list.map((item, i) => {
    return {
      label   : EntityLabel.get(sanitizeAccount(item)),
      href    : item.href,
      click   : true,
      onClick : function() {
        handleCrumbClick(item);
      }
    };
  });
  return crumbsList;
};

export const getCrumbs = ({
  group,
  currentGroup,
  radioValue,
  initialCrumb,
  handleCrumbClick
}) => {
  const accountTree   = setAccountTree([group], true);
  const [match]       = findCurrentAccountMatch(
    [group],
    currentGroup.href ? currentGroup : {href: radioValue}
  );
  const initialCrumbs = [initialCrumb];
  if (match && (match.href !== group.href)) {
    const parent = accountTree[entityId(accountTree[entityId(match)].parentId)];
    const selectedAccount = accountTree[entityId(accountTree[entityId(match)])];
    if (parent) {
      const crumbs = buildCrumbList({
        account          : selectedAccount,
        tree             : accountTree,
        handleCrumbClick : handleCrumbClick
      });
      initialCrumbs.push(...(crumbs || []));
    }
  }
  return initialCrumbs;
};
